import type { ReactNode } from 'react';
import { createContext, useContext, useMemo, useState } from 'react';

interface GlobalEContextType {
  loadScript: boolean;
  setLoadScript: (value: boolean) => void;
}

// Create a context object, not a namespace
export const GlobalEContext = createContext<GlobalEContextType | undefined>(
  undefined,
);

export const useGlobalEContext = () => {
  const context = useContext(GlobalEContext);
  if (!context) {
    throw new Error('useGlobalEContext must be used within a GlobalEProvider');
  }
  return context;
};

export const GlobalEProvider = ({ children }: { children: ReactNode }) => {
  const [loadScript, setLoadScript] = useState(false);

  const value = useMemo(() => ({ loadScript, setLoadScript }), [loadScript]);

  return (
    <GlobalEContext.Provider value={value}>{children}</GlobalEContext.Provider>
  );
};
